// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"f23b737d","845":"16bd8238"}[chunkId] + ".chunk.js";
};